import { api } from "./api";

export const documents = api.injectEndpoints({
  endpoints: builder => ({
    getDocuments: builder.query({
      query: () => {
        return {
          url: `${process.env.REACT_APP_API_URL}/trips/documents/general/`,

        }
      },
      keepUnusedDataFor: 5,
    }),
    addDocumet: builder.mutation({
      query: (formData) => ({
        url: `${process.env.REACT_APP_API_URL}/trips/documents/general/`,
        method: 'POST',
        body: formData,
      }),
    }),
    updateDocumet: builder.mutation({
      query: ({id, formData}) => ({
        url: `${process.env.REACT_APP_API_URL}/trips/documents/${id}/`,
        method: 'PUT',
        body: formData,
      }),
    }),
  })
});

export const {
  useGetDocumentsQuery,
  useAddDocumetMutation,
  useUpdateDocumetMutation,
} = documents;
